import React from "react";
import ImageGallery from 'react-image-gallery';

const ImageGalleryT = ({articuloNuevo,imagesArticulo}) => {
    const [images, setImages] = React.useState([]);
    const [imagesMobile, setImagesMobile] = React.useState([]);
    const [imagesCharged, setImagesCharged] = React.useState(false);

    /*const images = [
        {
            original: 'https://www.appsaudi.com.mx/resources/images/boutique/a545b595-ec7e-4b38-9327-3f5856281aab.jpg',
            thumbnail: 'https://www.appsaudi.com.mx/resources/images/boutique/a545b595-ec7e-4b38-9327-3f5856281aab.jpg',
            originalHeight: 640
        },
        {
            original: 'https://www.appsaudi.com.mx/resources/images/boutique/b4a97f4d-a1d9-40c0-8cea-56a606568064.jpg',
            thumbnail: 'https://www.appsaudi.com.mx/resources/images/boutique/b4a97f4d-a1d9-40c0-8cea-56a606568064.jpg',
            originalHeight: 640
        }
        
    ];*/
    
    const getImages = () => {
        if(!imagesCharged) {
            imagesArticulo.map( (item) => {
                let copyImage = images;
                copyImage.push({
                    original: process.env.REACT_APP_IMAGE_PATH + item.nombreReal,
                    thumbnail: process.env.REACT_APP_IMAGE_PATH + item.nombreReal,
                    originalHeight: 640,
                    thumbnailHeight: 52
                })

                let copyImageMobile = imagesMobile;
                copyImageMobile.push({
                    original: process.env.REACT_APP_IMAGE_PATH + item.nombreReal,
                    thumbnail: process.env.REACT_APP_IMAGE_PATH + item.nombreReal,
                    originalHeight: 640,
                    thumbnailHeight: 36
                })

                setImages(copyImage);
                setImagesMobile(copyImageMobile);
        
                return null;
            })
            

            setImagesCharged(true)
        }
    }
    getImages();

    return (
        <div>
            <div className="d-none d-md-block dropup">
                {
                    articuloNuevo &&
                        <div className="label--new v-align-c">
                            <span>New</span>
                        </div>
                }
                <ImageGallery 
                    items={images} 
                    originalHeight={200}
                    showPlayButton={false}
                    showNav={false}
                    showFullscreenButton={false}
                />
            </div>
            <div className="d-block d-md-none">
                {
                    articuloNuevo &&
                        <div className="label--new v-align-c">
                            <span>New</span>
                        </div>
                }
                <ImageGallery 
                    items={imagesMobile} 
                    originalHeight={352}
                    showPlayButton={false}
                    showNav={false}
                    showFullscreenButton={false}
                    thumbnailPosition="right"
                />
            </div>
        </div>
    );
};

export default ImageGalleryT;